import { SVGProps } from "react";

export const Waves = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    viewBox="0 0 1512 453"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M670 249.039c-404.8-83.6-639.667 113.333-715.5 203.5l-304.5-572.5c112.167 114.5 385.6 19.7 490-51.5 130.5-89 979.28 21.615 1295.5 72.5 130.5 21 150 66 166.5 53l51.5 387c-620.5 55-578.7-8.4-983.5-92"
      fill="#F6F8FF"
    ></path>
  </svg>
);
